import React from 'react';
import { motion } from 'framer-motion';
import './FloatingElements.css';

const FloatingElements = () => {
  const icons = ['🎥', '🎬', '📸', '🎵', '🎙️', '✨'];
  
  const elements = Array.from({ length: 12 }).map((_, i) => ({
    id: i,
    icon: icons[i % icons.length],
    x: Math.random() * 100,
    y: Math.random() * 100,
    size: Math.random() * (40 - 20) + 20,
    duration: Math.random() * (20 - 10) + 10,
    delay: Math.random() * 5
  }));

  return (
    <div className="floating-elements">
      {elements.map((el) => (
        <motion.div
          key={el.id}
          className="floating-element"
          style={{
            left: `${el.x}%`,
            top: `${el.y}%`,
            fontSize: `${el.size}px`
          }}
          animate={{
            y: [0, -30, 0],
            x: [0, 20, 0],
            rotate: [0, 360],
            opacity: [0.1, 0.3, 0.1]
          }}
          transition={{
            duration: el.duration,
            repeat: Infinity,
            delay: el.delay,
            ease: "easeInOut"
          }}
        >
          {el.icon}
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingElements;
